export default __webpack_public_path__ + "static/media/marketplace-selected.9e161eee.svg";